import Vue from 'vue'
import Vuelidate from 'vuelidate'
import store from './store.js'
import moment from 'moment'
import router from './routes/index'
import IndexPage from './views/index'
import { i18n } from './lang'
import './axiosConfig'
import { landingPageLogUsingPortal, sendError } from './utils/logging'

import VueAgile from 'vue-agile'
import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'

require('es6-promise').polyfill()

Vue.config.errorHandler = (err, vm, info) => {
  if (window.self !== window.top) {
    // Don't log errors in preview mode
    return
  }
  const stack = err.stack.split('\n')
  const errorPayload = JSON.stringify({
    error: {
      stack,
      message: err.message,
      name: err.name,
      description: err.description,
      number: err.number,
      fileName: err.fileName,
      lineNumber: err.lineNumber,
      columnNumber: err.columnNumber,
    },
    info,
    url: window.location.href,
  })
  sendError(errorPayload)
}

Vue.config.warnHandler = function (msg, vm, trace) {
  if (window.self !== window.top) {
    // Don't log errors in preview mode
    return
  }
  const errorPayload = JSON.stringify({
    message: msg,
    trace,
    url: window.location.href,
  })
  sendError(errorPayload)
}

Vue.prototype.moment = moment
window.moment = moment

Vue.prototype.$eventHub = new Vue()
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(Vuelidate)
Vue.use(VueAgile)
Vue.use(ToastPlugin)

console.log('Captive portal version 1.3.34')

const app = new Vue({
  el: '#app',
  components: { IndexPage },
  template: '<IndexPage/>',
  store,
  router,
  i18n,
});

export default app
